<template>
  <div class="header-wrapper pagedetail animate fadeIn" v-if="product">
    <h1 class="pagedetail__title text-center">สร้างกองผ้าป่า</h1>
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-md-8 col-md-offset-2">
          <div class="text-center text-white">กองผ้าป่าที่คุณสร้างนั้น สำหรับเงินบริจาคที่ได้มาทั้งหมด ทางโครงการจะนำมอบเป็นทุนให้กับเด็กและโรงเรียนในโครงการร้อยพลังการศึกษา</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8 pd-sm-0">
          <page-card
            ref="card"
            :title="form.title"
            :message="form.message"
            :province="form.provinceObject"
            :school="form.schoolObject"
            :owner="form.owner"
            :editing="editing" />
        </div>

        <div class="col-md-4">
          <!-- Create form -->
          <transition name="fade">
            <div v-if="!showRegisterForm" class="block-border radius block shadow">
              <page-form v-model="form" @submit="submit" :disabled="submitting" :submit-button-text="submitButtonText" />
            </div>
          </transition>

          <!-- Register form -->
          <transition name="fade">
            <div v-if="showRegisterForm" class="block-border radius block shadow">
              <page-register-form @submit="registered" @cancel="showRegisterForm = false" />
            </div>
          </transition>

          <!-- Login form -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PageCard from '@/components/PageCard'
  import PageForm from '@/components/PageForm'
  import PageRegisterForm from '@/components/PageRegisterForm'

  const UPLOAD_RETRY_LIMIT = 3
  const UPLOAD_RETRY_WAIT = 2500

  export default {
    name: 'PageCreateDefault',

    components: {
      PageRegisterForm,
      PageForm,
      PageCard
    },

    data () {
      return {
        submitting: false,
        product: null,
        editing: true,
        page: null,
        form: {
          title: '',
          message: '',
          province: '',
          provinceObject: null,
          school: '',
          schoolObject: null,
          owner: '',
          type: 1
        },
        showRegisterForm: false
      }
    },

    computed: {
      editMode () {
        return false
      },
      submitButtonText () {
        if (this.$store.state.token) {
          return 'บันทึก'
        }
      }
    },

    created () {
      this.getProduct()
    },

    methods: {
      getProduct () {
        this.$http.get(`products/${this.$route.params.sku}`)
        .then(resp => {
          this.product = resp.body
          if (!this.product.status) {
            this.product = null
            this.showErrorMessage('ไม่พบการบริจาค', true)
          }
        })
        .catch(err => {
          console.log(err)
          this.$modal.show({
            title: 'เกิดข้อผิดพลาด',
            text: 'ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้ง',
            okButtonText: 'ลองใหม่อีกครั้ง',
            ok: () => {
              window.location.reload()
            }
          })
        })
      },

      submit (form) {
        if (this.$store.state.user) {
          this.registered()
        } else {
          this.showRegisterForm = true
          this.$utils.scrollToElement('.wrapper--pageform')
        }
      },

      registered () {
        if (this.submitting) {
          return
        }
        this.submitting = true
        this.$modal.show({
          title: 'โปรดรอสักครู่',
          text: 'กำลังสร้างกองผ้าป่า...',
          okButton: false
        })

        this.validateProduct()
        .then(() => {
          this.createPage()
        })
        .catch(err => {
          console.log(err)
          this.showErrorMessage(err, true)
          this.submitting = false
        })
      },

      showErrorMessage (message, backHome) {
        this.$modal.show({
          title: 'เกิดข้อผิดพลาด',
          text: message,
          ok: () => {
            if (backHome) {
              this.$router.push('/')
            }
          }
        })
      },

      validateProduct () {
        if (!this.product) {
          return Promise.reject('ไม่พบการบริจาค')
        }

        return this.$http.get(`products/${this.$route.params.sku}`)
        .then(resp => {
          if (resp.body.status) {
            return resp
          } else {
            return Promise.reject('ไม่พบการบริจาค')
          }
        })
      },

      uploadToS3 (file, mimetype, presignedUrl, viewUrl) {
        let retryLimit = UPLOAD_RETRY_LIMIT

        let startUpload = () => {
          retryLimit--

          const oReq = new window.XMLHttpRequest()
          oReq.addEventListener('load', ev => {
            if (ev.target.status === 200) {
              this.$emit('uploaded', viewUrl.replace(/\?.*/, ''))
            } else {
              if (retryLimit > 0) {
                setTimeout(() => {
                  startUpload()
                }, UPLOAD_RETRY_WAIT)
              } else {
                this.errorHandler(oReq)
              }
            }
          })
          oReq.addEventListener('error', ev => {
            if (retryLimit > 0) {
              setTimeout(() => {
                startUpload()
              }, UPLOAD_RETRY_WAIT)
            } else {
              this.errorHandler(oReq)
            }
          })

          oReq.open('PUT', presignedUrl, true)
          oReq.setRequestHeader('Content-Type', mimetype)
          oReq.send(file)
        }

        startUpload()
      },

      uploadImage () {
        return this.$http.get('storage/presigned-url', { params: { mimetype: this.image.type } })
        .then(resp => {
          const presignedUrl = resp.body.presignedUrl
          const viewUrl = resp.body.url

          this.uploadToS3(this.image, this.image.type, presignedUrl, viewUrl)
        })
      },

      createPage () {
        const categories = []
        if (this.form.province) {
          categories.push(this.form.province)
        }
        if (this.form.school) {
          categories.push(this.form.school)
        }
        const payload = {
          title: this.form.title,
          email: this.$store.state.user.email,
          memberId: this.$store.state.user.uuid,
          phoneNumber: this.$store.state.user.telNo,
          fullName: this.form.owner,
          data: JSON.stringify({
            message: this.form.message,
            owner: this.form.owner
          }),
          ref_obj_id: this.product.id,
          ref_obj_type: 'product',
          categories: categories
        }

        this.$refs.card.captureCanvasToS3().then(result => {
          payload.image = result.image.split('?')[0]
          payload.share_image = result.shareImage.split('?')[0]

          this.$http.post('pages', payload)
          .then(resp => {
            this.$modal.hide()
            this.$router.push(`/pages/${resp.body.id}`)
          })
          .catch(err => {
            console.log(err)
            this.$modal.show({
              title: 'เกิดข้อผิดพลาด',
              text: 'ไม่สามารถสร้างกองผ้าป่าได้ กรุณาลองใหม่อีกครั้ง'
            })
          })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .block-border {
    overflow: hidden;
  }
  .pagedetail {
    .container {
      background: transparent;
      padding-left: 15px;
      padding-right: 15px;
    }
    .text-white {
      color: #fff;
      margin: 1em 0;
    }
    &__title {
      font-size: 2em;
      color: #fff;
      margin: 0 auto;
      font-weight: 500;
      text-align: center;
      max-width: 1120px;
    }
    .amount {
      text-align: right;
      font-size: 30px;
      font-weight: 600;
      color: #000;
    }
  }
  /* On screens that are 600px or less, set the background color to olive */
  @media screen and (max-width: 767px) {
    .pagedetail {
      &__title {
        font-size: 1.5em;
        margin: 30px auto 0;
      }
      .pd-sm-0 {
        padding: 0;
      }
    }
  }
  @media screen and (max-width: 414px) {
    .pagedetail {
      &__title {
        margin: 20px auto 0;
      }
      .text-white {
        font-size: 15px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// create.vue?fb0b0dc2